const OutlinedSelector = ({
  label,
  options,
  value,
  onChange,
  flag,
  disabled,
  isNoReply = false,
}) => {
  if (flag) {
    const handleChange = (e) => {
      const selectedOption = options.find(
        (option) => option.configId == e.target.value,
      );
      onChange(selectedOption); // Pass the entire selected option object
    };
    return (
      <div className="outlineSelector">
        <strong className="dropdown-label">{label}</strong>
        <div className="dropdown-content">
          <select id="selector" value={value.configId} onChange={handleChange}>
            {options.map((option, index) => (
              <option key={option.configId} value={option.configId}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="outlineSelector"
        style={{
          marginBottom: '10px',
          border: `2px solid ${disabled ? 'grey' : isNoReply ? 'red' : '#6bd888'}`,
        }}
        disabled={disabled}
      >
        <strong
          className="dropdown-label"
          style={{ color: disabled ? 'grey' : isNoReply ? 'red' : '#6bd888' }}
        >
          {label}
        </strong>
        <div
          className={`dropdown-content${disabled ? ' disabled' : ''}`}
          disabled={disabled}
        >
          {/* This is kinda Jank but it will capture the click event and prevent it from being muted by the select element allowing it to be passed to the parent element */}
          {disabled && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
              }}
            ></div>
          )}
          <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            style={disabled ? { paddingLeft: '0px' } : null}
          >
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
};

export default OutlinedSelector;
